define('view/layout/EmptyLayout',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    return Marionette.LayoutView.extend({

        template: '#empty_layout',

        regions: {
            content: '#sb_content'
        },

        getContentRegion: function () {
            return this.content;
        }

    });

});
